module.exports = __webpack_public_path__ + "static/media/SME-UPS-Campaign-Terms_and_Conditions.6f4b40c4.pdf";